CommonCoreInfo = LP.module 'CommonCoreInfo'

CommonCoreInfo.popovers = (selector) ->
  $(selector).on 'mouseenter', ->
    # close non CCSS popovers, click the X because `popover('hide')` method seems to be buggy
    $('button[data-dismiss="popover"]').click()
    CommonCoreInfo.showPopover @, $(@).data('id'), 'top'
  CommonCoreInfo.closePopoversOnOutsideClick()

CommonCoreInfo.showPopover = (el, node_id, placement) ->
  CommonCoreInfo.hidePopovers()
  $el       = $ el
  placement = placement or 'right'

  unless $el.data('bs.popover')
    getScrollPosition = -> $el.parents(':eq(2)').get(0).scrollTop
    scrollPos = getScrollPosition()
    @loadingNode = node_id
    $that = @
    $.getJSON("#{LP.config.standard_info_path}?id=#{node_id}").done (data) ->
      $el.popover(title: data.title, content: data.content, html: true, sanitize: false, trigger: 'hover', container: 'body', placement: placement)
        .addClass('js-cc-popover')
      # if the multiple requests are made show the popover only for the last one
      # also show the popover only if the content was not scrolled - avoid misplaced positioning
      $el.popover('show') if $that.loadingNode is node_id and scrollPos is getScrollPosition()

# Fast hovers over the CCSS items may end up with stuck popovers.
CommonCoreInfo.closePopoversOnOutsideClick = ->
  $('body').on 'click', (e) ->
    unless $(e.target).closest('.popover')[0]
      CommonCoreInfo.hidePopovers()

CommonCoreInfo.hidePopovers = ->
  $('.js-cc-popover').popover('hide')
